import { Component, Input } from '@angular/core';

import { IMeasureEvidenceSectionEvidence } from '@assess/shared/data-mart';

import { FormatDatePipe } from '../../pipes/format-date.pipe';

@Component({
  selector: 'assess-evidence-item',
  templateUrl: './evidence-item.component.html',
  styleUrls: ['./evidence-item.component.scss'],
  providers: [FormatDatePipe],
})
export class EvidenceItemComponent {
  @Input() evidence!: IMeasureEvidenceSectionEvidence;

  constructor(private readonly formatDatePipe: FormatDatePipe) {}

  formatEvidenceInfo(evidence: IMeasureEvidenceSectionEvidence) {
    const evidenceDate = evidence.date ? this.formatDatePipe.transform(evidence.date) : undefined;

    return [evidenceDate, evidence.code].filter(Boolean).join(' • ');
  }
}
